import { LiteralValue } from './LiteralValue';

export class NumberValue extends LiteralValue<number> {}
